export default [{
        path: '/management',
        name: 'management',
        component: () =>
            import ('@/views/management/Management.vue'),
        meta: {
            pageTitle: 'Management',
            breadcrumb: [{
                text: 'Management',
                active: true,
            }, ],
        },
    },

    {
        path: '/languages',
        name: 'languages',
        component: () =>
            import ('@/views/management/languages/Languages.vue'),
        meta: {
            pageTitle: 'Languages',
            breadcrumb: [{
                text: 'Languages',
                active: true,
            }, ],
        },
    },

    {
        path: '/language/create',
        name: 'language-create',
        component: () =>
            import ('@/views/management/languages/LanguageCreate.vue'),
        meta: {
            pageTitle: 'Languages',
            breadcrumb: [{
                text: 'Languages',
                active: true,
            }, ],
        },
    },
    {
        path: '/language/edit/:idParam',
        name: 'language-edit',
        component: () =>
            import ('@/views/management/languages/LanguageEdit.vue'),
        meta: {
            pageTitle: 'Languages',
            breadcrumb: [{

                text: 'Languages',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/products',
        name: 'products',
        component: () =>
            import ('@/views/management/products/Products.vue'),
        meta: {
            pageTitle: 'Products',
            breadcrumb: [{
                text: 'Products',
                active: true,
            }, ],
        },
    },

    {
        path: '/product/create',
        name: 'product-create',
        component: () =>
            import ('@/views/management/products/ProductCreate.vue'),
        meta: {
            pageTitle: 'Products',
            breadcrumb: [{
                text: 'Products',
                active: true,
            }, ],
        },
    },
    {
        path: '/product/translation/create/:idParam',
        name: 'product-translation-create',
        component: () =>
            import ('@/views/management/products/ProductCreateTranslation.vue'),
        meta: {
            pageTitle: 'Products',
            breadcrumb: [{

                text: 'Products',
            }, {
                text: 'Create Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/product/translation/edit/:idParam',
        name: 'product-translation-edit',
        component: () =>
            import ('@/views/management/products/ProductEditTranslation.vue'),
        meta: {
            pageTitle: 'Languages',
            breadcrumb: [{

                text: 'Languages',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/translations',
        name: 'translations',
        component: () =>
            import ('@/views/management/translations/Translations.vue'),
        meta: {
            pageTitle: 'Translations',
            breadcrumb: [{
                text: 'Translations',
                active: true,
            }, ],
        },
    },
    {
        path: '/translation/create',
        name: 'translation-create',
        component: () =>
            import ('@/views/management/translations/TranslationCreate.vue'),
        meta: {
            pageTitle: 'Translations',
            breadcrumb: [{
                text: 'Translations',
                active: true,
            }, ],
        },
    },
    {
        path: '/translation/edit/:idParam',
        name: 'translation-edit',
        component: () =>
            import ('@/views/management/translations/TranslationEdit.vue'),
        meta: {
            pageTitle: 'Translations',
            breadcrumb: [{

                text: 'Translations',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/questions',
        name: 'questions',
        component: () =>
            import ('@/views/management/questions/Questions.vue'),
        meta: {
            pageTitle: 'Questions',
            breadcrumb: [{
                text: 'Questions',
                active: true,
            }, ],
        },
    },
    {
        path: '/question/create',
        name: 'question-create',
        component: () =>
            import ('@/views/management/questions/QuestionCreate.vue'),
        meta: {
            pageTitle: 'Questions',
            breadcrumb: [{
                text: 'Questions',
                active: true,
            }, ],
        },
    },
    {
        path: '/question/translation/create/:idParam',
        name: 'question-translation-create',
        component: () =>
            import ('@/views/management/questions/QuestionCreateTranslation.vue'),
        meta: {
            pageTitle: 'Questions',
            breadcrumb: [{

                text: 'Questions',
            }, {
                text: 'Create Question',
                active: true,
            }, ],
        },
    },
    {
        path: '/question/translation/edit/:idParam',
        name: 'question-translation-edit',
        component: () =>
            import ('@/views/management/questions/QuestionEditTranslation.vue'),
        meta: {
            pageTitle: 'Questions',
            breadcrumb: [{

                text: 'Questions',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/products-question',
        name: 'products-question',
        component: () =>
            import ('@/views/management/product-questions/ProductsQuestion.vue'),
        meta: {
            pageTitle: 'ProductQuestion',
            breadcrumb: [{
                text: 'ProductQuestion',
                active: true,
            }, ],
        },
    },
    {
        path: '/product-questions/:idParam',
        name: 'product-questions',
        component: () =>
            import ('@/views/management/product-questions/ProductQuestions.vue'),
        meta: {
            pageTitle: 'ProductQuestions',
            breadcrumb: [{

                    text: 'ProductQuestions',
                }

            ],
        },
    },
    {
        path: '/product-question/create/:idParam',
        name: 'product-question-create',
        component: () =>
            import ('@/views/management/product-questions/ProductQuestionCreate.vue'),
        meta: {
            pageTitle: 'ProductQuestion',
            breadcrumb: [{
                text: 'ProductQuestion Create',
                active: true,
            }, ],
        },
    },
    {
        path: '/product-question/edit/:idParam',
        name: 'product-question-edit',
        component: () =>
            import ('@/views/management/product-questions/ProductQuestionEdit.vue'),
        meta: {
            pageTitle: 'ProductQuestion',
            breadcrumb: [{
                text: 'ProductQuestion Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/analysis-results',
        name: 'analysis-results',
        component: () =>
            import ('@/views/management/analysis-results/AnalysisResults.vue'),
        meta: {
            pageTitle: 'AnalysisResults',
            breadcrumb: [{
                text: 'AnalysisResults',
                active: true,
            }, ],
        },
    },
    {
        path: '/analysis-result/edit/:idParam',
        name: 'analysis-result-edit',
        component: () =>
            import ('@/views/management/analysis-results/AnalysisResultEdit.vue'),
        meta: {
            pageTitle: 'AnalysisResults',
            breadcrumb: [{

                text: 'AnalysisResults',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },

    {
        path: '/categories',
        name: 'categories',
        component: () =>
            import ('@/views/management/categories/Categories.vue'),
        meta: {
            pageTitle: 'Categories',
            breadcrumb: [{
                text: 'Categories',
                active: true,
            }, ],
        },
    },
    {
        path: '/categories/create',
        name: 'categories-create',
        component: () =>
            import ('@/views/management/categories/CategoryCreate.vue'),
        meta: {
            pageTitle: 'Categories',
            breadcrumb: [{

                text: 'Categories',
            }, {
                text: 'Create',
                active: true,
            }, ],
        },
    },
    {
        path: '/categories/edit/:slugParam',
        name: 'categories-edit',
        component: () =>
            import ('@/views/management/categories/CategoryEdit.vue'),
        meta: {
            pageTitle: 'Categories',
            breadcrumb: [{

                text: 'Categories',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/categories/create/translation/:idParam',
        name: 'categories-create-translation',
        component: () =>
            import ('@/views/management/categories/CategoryCreateTranslation.vue'),
        meta: {
            pageTitle: 'Categories',
            breadcrumb: [{

                text: 'Categories',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/contents/categories',
        name: 'contents-categories',
        component: () =>
            import ('@/views/management/contents/ContentsCategories.vue'),
        meta: {
            pageTitle: 'Contents',
            breadcrumb: [{
                text: 'Contents',
            }, {
                text: 'Categories',
                active: true,
            }, ],
        },
    },
    {
        path: '/contents/categories/:slugParam',
        name: 'contents-categories-list',
        component: () =>
            import ('@/views/management/contents/Contents.vue'),
        meta: {
            pageTitle: 'ContentsList',
            breadcrumb: [{
                text: 'Contents',
            }, {
                text: 'Categories',
            }, {
                text: 'List',
                active: true,
            }, ],
        },
    },
    {
        path: '/contents/create/:slugParam',
        name: 'contents-create',
        component: () =>
            import ('@/views/management/contents/ContentCreate.vue'),
        meta: {
            pageTitle: 'Contents',
            breadcrumb: [{

                text: 'Contents',
            }, {
                text: 'Create',
                active: true,
            }, ],
        },
    },
    {
        path: '/contents/edit/:slugParam',
        name: 'contents-edit',
        component: () =>
            import ('@/views/management/contents/ContentEdit.vue'),
        meta: {
            pageTitle: 'Contents',
            breadcrumb: [{

                text: 'Contents',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/contents/create/translation/:slugParam',
        name: 'contents-create-translation',
        component: () =>
            import ('@/views/management/contents/ContentCreateTranslation.vue'),
        meta: {
            pageTitle: 'Contents',
            breadcrumb: [{

                text: 'Contents',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/educators',
        name: 'educators',
        component: () =>
            import ('@/views/management/educators/Educators.vue'),
        meta: {
            pageTitle: 'Educators',
            breadcrumb: [{
                text: 'Educators',
                active: true,
            }, ],
        },
    },
    {
        path: '/educators/create',
        name: 'educators-create',
        component: () =>
            import ('@/views/management/educators/EducatorCreate.vue'),
        meta: {
            pageTitle: 'Educators',
            breadcrumb: [{

                text: 'Educators',
            }, {
                text: 'Create',
                active: true,
            }, ],
        },
    },
    {
        path: '/educators/edit/:slugParam',
        name: 'educators-edit',
        component: () =>
            import ('@/views/management/educators/EducatorEdit.vue'),
        meta: {
            pageTitle: 'Educators',
            breadcrumb: [{

                text: 'Educators',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/educators/create/translation/:slugParam',
        name: 'educators-create-translation',
        component: () =>
            import ('@/views/management/educators/EducatorCreateTranslation.vue'),
        meta: {
            pageTitle: 'Educators',
            breadcrumb: [{

                text: 'Educators',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/sliders/home',
        name: 'sliders-home',
        component: () =>
            import ('@/views/management/sliders/home/HomeSliders.vue'),
        meta: {
            pageTitle: 'Home Slider',
            breadcrumb: [{

                text: 'Home Slider',
                active: true,
            }, ],
        },
    },
    {
        path: '/sliders/home/create',
        name: 'sliders-home-create',
        component: () =>
            import ('@/views/management/sliders/home/HomeSliderCreate.vue'),
        meta: {
            pageTitle: 'Home Slider',
            breadcrumb: [{

                    text: 'Home Slider',
                    active: true,
                },
                {

                    text: 'Create',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/sliders/home/edit/:idParam',
        name: 'sliders-home-edit',
        component: () =>
            import ('@/views/management/sliders/home/HomeSliderEdit.vue'),
        meta: {
            pageTitle: 'Home Slider',
            breadcrumb: [{

                text: 'Home Slider',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/sliders/home/create/translation/:idParam',
        name: 'sliders-home-create-translation',
        component: () =>
            import ('@/views/management/sliders/home/HomeSliderCreateTranslation.vue'),
        meta: {
            pageTitle: 'Home Slider',
            breadcrumb: [{

                text: 'Events',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/sliders/highlights',
        name: 'sliders-highlights',
        component: () =>
            import ('@/views/management/sliders/highlights/HighlightsSlider.vue'),
        meta: {
            pageTitle: 'Highlights',
            breadcrumb: [{
                text: 'Highlights',
            }, ],
        },
    },
    {
        path: '/sliders/programs',
        name: 'sliders-programs',
        component: () =>
            import ('@/views/management/sliders/programs/ProgramsSlider.vue'),
        meta: {
            pageTitle: 'Programs',
            breadcrumb: [{
                text: 'Programs',
            }, ],
        },
    },
    {
        path: '/sliders/interesteds',
        name: 'sliders-interesteds',
        component: () =>
            import ('@/views/management/sliders/interesteds/InterestedsSlider.vue'),
        meta: {
            pageTitle: 'Interesteds',
            breadcrumb: [{
                text: 'Interesteds',
            }, ],
        },
    },
    {
        path: '/sliders/podcasts',
        name: 'sliders-podcasts',
        component: () =>
            import ('@/views/management/sliders/podcasts/PodcastsSlider.vue'),
        meta: {
            pageTitle: 'Podcasts',
            breadcrumb: [{
                text: 'Podcasts',
            }, ],
        },
    },
    {
        path: '/events',
        name: 'events',
        component: () =>
            import ('@/views/management/events/Events.vue'),
        meta: {
            pageTitle: 'Events',
            breadcrumb: [{

                text: 'Events',
                active: true,
            }, ],
        },
    },
    {
        path: '/events/create',
        name: 'events-create',
        component: () =>
            import ('@/views/management/events/EventCreate.vue'),
        meta: {
            pageTitle: 'Events',
            breadcrumb: [{

                    text: 'Events',
                    active: true,
                },
                {

                    text: 'Create',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/events/edit/:slugParam',
        name: 'events-edit',
        component: () =>
            import ('@/views/management/events/EventEdit.vue'),
        meta: {
            pageTitle: 'Events',
            breadcrumb: [{

                text: 'Events',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/events/create/translation/:slugParam',
        name: 'events-create-translation',
        component: () =>
            import ('@/views/management/events/EventCreateTranslation.vue'),
        meta: {
            pageTitle: 'Events',
            breadcrumb: [{

                text: 'Events',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/podcasts',
        name: 'podcasts',
        component: () =>
            import ('@/views/management/podcasts/Podcasts.vue'),
        meta: {
            pageTitle: 'Podcasts',
            breadcrumb: [{

                text: 'Podcasts',
                active: true,
            }, ],
        },
    },
    {
        path: '/podcasts/create',
        name: 'podcasts-create',
        component: () =>
            import ('@/views/management/podcasts/PodcastCreate.vue'),
        meta: {
            pageTitle: 'Podcasts',
            breadcrumb: [{

                    text: 'Podcasts',
                    active: true,
                },
                {

                    text: 'Create',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/podcasts/edit/:slugParam',
        name: 'podcasts-edit',
        component: () =>
            import ('@/views/management/podcasts/PodcastEdit.vue'),
        meta: {
            pageTitle: 'Podcasts',
            breadcrumb: [{

                text: 'Podcasts',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/podcasts/create/translation/:slugParam',
        name: 'podcasts-create-translation',
        component: () =>
            import ('@/views/management/podcasts/PodcastCreateTranslation.vue'),
        meta: {
            pageTitle: 'Podcasts',
            breadcrumb: [{

                text: 'Podcasts',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    }, {
        path: '/galleries',
        name: 'galleries',
        component: () =>
            import ('@/views/management/galleries/Galleries.vue'),
        meta: {
            pageTitle: 'Galleries',
            breadcrumb: [{

                text: 'Galleries',
                active: true,
            }, ],
        },
    },
    {
        path: '/galleries/create',
        name: 'galleries-create',
        component: () =>
            import ('@/views/management/galleries/GalleryCreate.vue'),
        meta: {
            pageTitle: 'Galleries',
            breadcrumb: [{

                    text: 'Galleries',
                    active: true,
                },
                {

                    text: 'Create',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/galleries/edit/:slugParam',
        name: 'galleries-edit',
        component: () =>
            import ('@/views/management/galleries/GalleryEdit.vue'),
        meta: {
            pageTitle: 'Galleries',
            breadcrumb: [{

                text: 'Galleries',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/galleries/create/translation/:slugParam',
        name: 'galleries-create-translation',
        component: () =>
            import ('@/views/management/galleries/GalleryCreateTranslation.vue'),
        meta: {
            pageTitle: 'Galleries',
            breadcrumb: [{

                text: 'Galleries',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/books',
        name: 'books',
        component: () =>
            import ('@/views/management/books/Books.vue'),
        meta: {
            pageTitle: 'Books',
            breadcrumb: [{

                text: 'Books',
                active: true,
            }, ],
        },
    },
    {
        path: '/books/create',
        name: 'books-create',
        component: () =>
            import ('@/views/management/books/BookCreate.vue'),
        meta: {
            pageTitle: 'Books',
            breadcrumb: [{

                    text: 'Books',
                    active: true,
                },
                {

                    text: 'Create',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/books/edit/:idParam',
        name: 'books-edit',
        component: () =>
            import ('@/views/management/books/BookEdit.vue'),
        meta: {
            pageTitle: 'Books',
            breadcrumb: [{

                text: 'Books',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/books/create/translation/:idParam',
        name: 'books-create-translation',
        component: () =>
            import ('@/views/management/books/BookCreateTranslation.vue'),
        meta: {
            pageTitle: 'Books',
            breadcrumb: [{

                text: 'Books',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/forms/gsys',
        name: 'forms-gsys',
        component: () =>
            import ('@/views/management/forms/Gsys.vue'),
        meta: {
            pageTitle: 'Gsys',
            breadcrumb: [{

                text: 'Forms',
            }, {
                text: 'Gsys',
                active: true,
            }, ],
        },
    },
    {
        path: '/forms/contacts',
        name: 'forms-contacts',
        component: () =>
            import ('@/views/management/forms/Contacts.vue'),
        meta: {
            pageTitle: 'Contacts',
            breadcrumb: [{

                text: 'Forms',
            }, {
                text: 'Contacts',
                active: true,
            }, ],
        },
    },
    {
        path: '/forms/participants',
        name: 'forms-participants',
        component: () =>
            import ('@/views/management/forms/Participants.vue'),
        meta: {
            pageTitle: 'Participants',
            breadcrumb: [{

                text: 'Forms',
            }, {
                text: 'Participants',
                active: true,
            }, ],
        },
    },
    {
        path: '/forms/newsletters',
        name: 'forms-newsletters',
        component: () =>
            import ('@/views/management/forms/Newsletters.vue'),
        meta: {
            pageTitle: 'Newsletters',
            breadcrumb: [{

                text: 'Forms',
            }, {
                text: 'Newsletters',
                active: true,
            }, ],
        },
    },
    {
        path: '/devices',
        name: 'devices',
        component: () =>
            import ('@/views/management/devices/Devices.vue'),
        meta: {
            pageTitle: 'Devices',
            breadcrumb: [{

                text: 'Forms',
            }, {
                text: 'Devices',
                active: true,
            }, ],
        },
    },
    {
        path: '/device/edit/:idParam',
        name: 'device-edit',
        component: () =>
            import ('@/views/management/devices/DeviceEdit.vue'),
        meta: {
            pageTitle: 'Devices',
            breadcrumb: [{

                text: 'Devices',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/users',
        name: 'users',
        component: () =>
            import ('@/views/management/users/Users.vue'),
        meta: {
            pageTitle: 'Users',
            breadcrumb: [{

                text: 'Forms',
            }, {
                text: 'Users',
                active: true,
            }, ],
        },
    },

    {
        path: '/user/edit/:idParam',
        name: 'user-edit',
        component: () =>
            import ('@/views/management/users/UserEdit.vue'),
        meta: {
            pageTitle: 'Users',
            breadcrumb: [{

                text: 'Users',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/airports',
        name: 'airports',
        component: () =>
            import ('@/views/management/airports/Airports.vue'),
        meta: {
            pageTitle: 'Airports',
            breadcrumb: [{

                text: 'Forms',
            }, {
                text: 'Airports',
                active: true,
            }, ],
        },
    },
    {
        path: '/airport/products',
        name: 'airport-products',
        component: () =>
            import ('@/views/management/airport-products/AirportProducts.vue'),
        meta: {
            pageTitle: 'Airport Products',
            breadcrumb: [{

                text: 'Airport',
            }, {
                text: 'Products',
                active: true,
            }, ],
            action: 'airport-products',
            subject: 'all'
        },
    }

]